import '@fontsource-variable/fraunces';
import '@fontsource-variable/manrope';
import '@phosphor-icons/web/regular';
import '@tov-plus/ui/styles/design-system.css';
import '@tov-plus/ui/styles/app-base.css';

import { installProductIconLinks } from '@tov-plus/assets/branding';
import {
  initFrontendBrowserTelemetry,
  parseFrontendTelemetryConfig,
} from '@tov-plus/observability/browser';
import { createMissingTranslationSentryReporter } from '@tov-plus/observability/sentry/missingTranslation';
import { registerPwaServiceWorker } from '@tov-plus/pwa';
import * as Sentry from '@sentry/browser';
import {
  configureLocalizationComponent,
  setMissingTranslationReporter,
} from '@tov-plus/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initGuestsAnalytics } from './analytics/initAnalytics';
import { App } from './app/App';
import { initGuestsSentry } from './observability/initSentry';
import './styles/app.css';
import './styles/guest-landing.css';
import './styles/guest-home-editorial.css';

const rootElement = document.getElementById('root');
configureLocalizationComponent('guests-website');
const sentryOptions = initGuestsSentry();
const telemetryConfig = parseFrontendTelemetryConfig(
  {
    endpoint: (import.meta.env['VITE_OTEL_EXPORTER_OTLP_ENDPOINT'] ??
      import.meta.env['PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT']) as
      string | undefined,
    environment: (import.meta.env['VITE_SENTRY_ENVIRONMENT'] ??
      import.meta.env['PUBLIC_SENTRY_ENVIRONMENT']) as string | undefined,
    release: (import.meta.env['VITE_SENTRY_RELEASE'] ??
      import.meta.env['PUBLIC_SENTRY_RELEASE']) as string | undefined,
    enabled: (import.meta.env['VITE_OTEL_EXPORTER_OTLP_ENABLED'] ??
      import.meta.env['PUBLIC_OTEL_EXPORTER_OTLP_ENABLED']) as
      string | undefined,
  },
  {
    app: '@tov-plus/guests',
    surface: 'guests',
    serviceName: 'guest_website',
  },
);

if (!rootElement) {
  console.error(
    "Guest app root element was not found. Ensure index.html includes an element with id='root'.",
  );
} else {
  installProductIconLinks(document);
  initGuestsAnalytics();
  initFrontendBrowserTelemetry(telemetryConfig);
  if (!import.meta.env.DEV) {
    void registerPwaServiceWorker();
  }
  if (sentryOptions?.enabled) {
    Sentry.init(sentryOptions);
    setMissingTranslationReporter(
      createMissingTranslationSentryReporter(Sentry, 'guests'),
    );
  } else {
    setMissingTranslationReporter(null);
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
